export const profileSuppliesStyles = (theme) => ({
  panel: {
    backgroundColor: theme.palette.grey[100],
    boxShadow: '0 4px 18px 0 rgba(0, 0, 0, 0.02)',
    borderRadius: '6px',
  },
  subpanel: {
    marginBottom: '30px',
  },
})
